<div class="input-group" [ngClass]="{ 'input-group-sm': small_input }">
  <input
    [(ngModel)]="matterSearchTerm"
    type="text"
    name="matter-search"
    [appAutocomplete]="'/matters/field_search'"
    (autocompleteSelect)="matterSearchOnSelect($event)"
    [include_item]="include_item"
    [placeholder]="placeholder || 'Search for matter'"
    class="form-control"
    [disabled]="!select_only && (!!matterId || !editable)"
    name="matter_search"
    ngDefaultControl
  />
  <div class="input-group-append" style="padding: 0px !important" *ngIf="!select_only">
    <button type="button" class="btn btn-primary" [disabled]="!matterId || !editable" (click)="clearSelectedMatter()">
      <i class="fas fa-pencil-alt"></i>
    </button>
  </div>
</div>
